import React from 'react'
import { ReactComponent as LoginCross } from "../../assets/icons/notification/login-cross.svg";
import { enqueueSnackbar, closeSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const ListTransaction = ({ listTransaction, isLoadedList, isMobile }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const rejectReason = (reason) => {
    enqueueSnackbar(`${t("transactions.causeRefusal")} ${reason}`, {
      action: (snackbarId) => (
        <button
          className="close-button"
          onClick={() => closeSnackbar(snackbarId)}
        >
          <LoginCross />
        </button>
      ), autoHideDuration: 3000, variant: 'error'
    });
  }

  const returnIcon = (status) => {
    if (status == "accepted") return <div className='statusAccepted'>{t("transactions.accepted")}</div>
    if (status == "waiting") return <div className='statusWait'>{t("transactions.wait")}</div>
    if (status == "rejected") return <div className='statusRejected'>{t("transactions.rejected")}</div>
  }

  function formatDate(inputDate) {
    const date = new Date(inputDate);
    const year = date.getFullYear().toString().substr(-2);
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${year}.${month}.${day} ${hours}:${minutes}`;
  }

  const goToTransaction = (transaction) => {
    transaction.isBankRefill && transaction.status == "waiting" && transaction.action != "withdraw"
      && navigate(`/account/deposit?bankTransferId=${transaction.id}&amount=${transaction.value}`)
  }

  if (!isLoadedList) {
    return <ul className='history'>Loading</ul>
  }

  // ---- Мобильная раскладка: карточки вместо таблицы из 6 колонок ----
  if (isMobile) {
    return (
      <ul className='history history-mobile'>
        {listTransaction.map((transaction, idx) => (
          <li
            className={transaction.isBankRefill && transaction.status == "waiting" ? 'clickable' : ''}
            key={idx}
            onClick={() => goToTransaction(transaction)}
          >
            <div className="row-top">
              <div className="tx-main">
                {transaction.icon_link && (
                  <img
                    className="currency-icon"
                    src={`https://api-ru.fynex.cc/api/${transaction.icon_link.toLowerCase()}`}
                    alt=""
                  />
                )}
                <div className="tx-main-text">
                  <span className="tx-type">{transaction.action != "refill" ? t("transactions.conclusion") : t("transactions.despoit")}</span>
                  <span className="tx-currency">{transaction.currency_type}</span>
                </div>
              </div>
              <div
                className="tx-status"
                onClick={transaction.status == "rejected" ? (e) => { e.stopPropagation(); rejectReason(transaction.comment_rejected) } : undefined}
              >
                {transaction.status == "rejected" &&
                  <button className="reject-reason">?</button>
                }
                {returnIcon(transaction.status)}
              </div>
            </div>
            <div className="row-bottom">
              <span className="tx-id">ID {transaction.id}</span>
              <span className={transaction.action == "refill" ? "sum" : "sum minus"}>
                {transaction.action == "refill" ? "+" : "-"} {transaction.value}
              </span>
              <span className="tx-date">{formatDate(transaction.date)}</span>
            </div>
          </li>
        ))}
      </ul>
    )
  }

  // ---- Десктопная раскладка (без изменений) ----
  return (
    <ul className='history'>
      {listTransaction.map((transaction, idx) => (
        <li className={transaction.isBankRefill && transaction.status == "waiting" ? 'clickable' : ''} key={idx} onClick={() => goToTransaction(transaction)}>
          <p>{transaction.action != "refill" ? t("transactions.conclusion") : t("transactions.despoit")}</p>
          <p className="name">{transaction.currency_type}</p>
          <p className="id">{transaction.id}</p>
          <p className={transaction.action == "refill" ? "sum" : "sum minus"}>{transaction.action == "refill" ? "+" : "-"} {transaction.value}</p>
          <p className="date">{formatDate(transaction.date)}</p>
          <p className="status" onClick={transaction.status == "rejected" ? () => rejectReason(transaction.comment_rejected) : null}>
            {transaction.status == "rejected" &&
              <button className="reject-reason">
                ?
              </button>
            }
            {returnIcon(transaction.status)}
          </p>
        </li>
      ))}
    </ul>
  )
}

export default ListTransaction
